import { render, staticRenderFns } from "./SelectAppraisal.vue?vue&type=template&id=a24e3552&"
import script from "./SelectAppraisal.vue?vue&type=script&lang=js&"
export * from "./SelectAppraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports